
function OuterContainer({children}) {
    return (
        <div className="relative max-w-screen-md min-h-screen mx-auto bg-white">
          {children}
        </div>
    );
}

export default OuterContainer;
